import { __assign, __awaiter, __generator, __read, __spread } from "tslib";
import { Resource } from '@ekuaibao/fetch';
var DEFAULT_BATCH_WINDOW_MS = 48;
var REQUEST_KEY_FIELD = 'dimensionItemFieldName';
var BatchRequestManager = (function () {
    function BatchRequestManager(config) {
        var _a, _b;
        this.pendingRequests = [];
        this.flushTimer = null;
        this.api = new Resource(config.basePath);
        this.batchEndpoint = config.batchEndpoint;
        this.batchWindowMs = (_a = config.batchWindowMs) !== null && _a !== void 0 ? _a : DEFAULT_BATCH_WINDOW_MS;
        this.keyField = (_b = config.keyField) !== null && _b !== void 0 ? _b : REQUEST_KEY_FIELD;
    }
    BatchRequestManager.prototype.batchRequest = function (params) {
        return __awaiter(this, void 0, Promise, function () {
            var fieldKey;
            var _this = this;
            return __generator(this, function (_a) {
                fieldKey = (params === null || params === void 0 ? void 0 : params[this.keyField]) || '';
                return [2, new Promise(function (resolve, reject) {
                        _this.pendingRequests.push({
                            resolve: resolve,
                            reject: reject,
                            fieldKey: fieldKey,
                            params: params
                        });
                        _this.scheduleFlush();
                    })];
            });
        });
    };
    BatchRequestManager.prototype.scheduleFlush = function () {
        var _this = this;
        if (this.flushTimer !== null)
            return;
        this.flushTimer = setTimeout(function () {
            _this.flushTimer = null;
            _this.flush();
        }, this.batchWindowMs);
    };
    BatchRequestManager.prototype.flush = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var requests, mergedForm, batchPayload, response, values_1, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        requests = __spread(this.pendingRequests);
                        this.pendingRequests = [];
                        if (requests.length === 0)
                            return [2];
                        mergedForm = requests.reduce(function (acc, _a) {
                            var params = _a.params;
                            return __assign(__assign({}, acc), params === null || params === void 0 ? void 0 : params.form);
                        }, {});
                        batchPayload = {
                            form: mergedForm,
                            submitterId: (_b = (_a = requests[0]) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.submitterId,
                            requests: requests.map(function (_a) {
                                var params = _a.params;
                                return __assign(__assign({}, params), { form: {} });
                            })
                        };
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4, this.api.POST(this.batchEndpoint, batchPayload)];
                    case 2:
                        response = _c.sent();
                        values_1 = (response === null || response === void 0 ? void 0 : response.value) || {};
                        requests.forEach(function (_a) {
                            var resolve = _a.resolve, fieldKey = _a.fieldKey;
                            var data = values_1[fieldKey] || [];
                            resolve(data);
                        });
                        return [3, 4];
                    case 3:
                        error_1 = _c.sent();
                        requests.forEach(function (_a) {
                            var reject = _a.reject;
                            return reject(error_1);
                        });
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    BatchRequestManager.prototype.destroy = function () {
        if (this.flushTimer !== null) {
            clearTimeout(this.flushTimer);
            this.flushTimer = null;
        }
        this.pendingRequests.forEach(function (_a) {
            var reject = _a.reject;
            reject(new Error('BatchRequestManager destroyed'));
        });
        this.pendingRequests = [];
    };
    return BatchRequestManager;
}());
export { BatchRequestManager };
export var recordLinkBatchManager = new BatchRequestManager({
    basePath: '/api/flow/v2/referables',
    batchEndpoint: '/getBatchByIds',
    keyField: 'dimensionItemFieldName'
});
